import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCheckoutResultDialogComponent } from './order-checkout-result-dialog.component';
import { PriceSimpleMHComponent } from '../../../price/simple/price-simple.component';
import { PaymentInfoModule } from '../../../payment-info/payment-info.module';


@NgModule({
    declarations: [
        OrderCheckoutResultDialogComponent,
    ],
    imports: [
        CommonModule,
        PriceSimpleMHComponent,
        PaymentInfoModule,
    ]
})
export class CheckoutResultDialogModule { }
